import React, { useState } from "react";
import * as XLSX from "xlsx";
import ObtieneDatosCookies from "../tools/obtieneDatosCookiesUsuario";
import regresaBienFecha from "../tools/regresaBienFecha";

const ResumenDocentes = ({ data, escuela,fecha }) => {
  const [sortConfig, setSortConfig] = useState({ key: "#", direction: "asc" });
const Usuario=ObtieneDatosCookies()
  const resumenMap = new Map();

  data.forEach((item) => {
    const { docenteApellido, docenteNombres, asignacionMaterias } = item.plantelDocente;
    const horaIngreso = item.hora || "Sin horario";
    const docente = `${docenteApellido}, ${docenteNombres.trim()}`;
    const dni=item.docenteDni
    asignacionMaterias.forEach(({ materia }) => {
      if (escuela && materia.escuela !== escuela) return;

      const key = docente;

      if (!resumenMap.has(key)) {
        resumenMap.set(key, {
          docente,
          dni:dni,
          horarioIngreso: horaIngreso,
          cursos: {},
        });
      }

      const docenteData = resumenMap.get(key);
      const curso = materia.curso;
      const nombreMateria = materia.nombreMateria;

      if (!docenteData.cursos[curso]) {
        docenteData.cursos[curso] = new Set();
      }

      docenteData.cursos[curso].add(nombreMateria);
    });
  });

  let resumen = Array.from(resumenMap.values());

  const sortBy = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const getComparator = (key) => {
    return (a, b) => {
      let valA = a[key];
      let valB = b[key];
      if (key === "#") return 0;
      if (typeof valA === "string") valA = valA.toLowerCase();
      if (typeof valB === "string") valB = valB.toLowerCase();
      if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
      if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    };
  };

  if (sortConfig.key !== "#") {
    resumen = [...resumen].sort(getComparator(sortConfig.key));
  }

  const exportarExcel = () => {
    const datosExport = resumen.map((fila) => ({
      Docente: fila.docente,
      DNI:fila.dni,
      "Horario Ingreso": fila.horarioIngreso,
      Cursos: Object.entries(fila.cursos)
        .map(([curso, materias]) => `${curso}: ${Array.from(materias).join(", ")}`)
        .join(" | "),
    }));

    const ws = XLSX.utils.json_to_sheet(datosExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Huellas");

    const fechaHoy = new Date().toISOString().split("T")[0];
    const escuelaNombre = escuela ? escuela.replace(/\s+/g, "_") : "General";
    const nombreArchivo = `huellas_docentes_${escuelaNombre}_${fechaHoy}.xlsx`;

    XLSX.writeFile(wb, nombreArchivo);
  };

  const getHeaderClass = (key) =>
    `cursor-pointer border border-gray-300 px-4 py-2 text-left ${
      sortConfig.key === key ? "bg-blue-200 font-bold" : ""
    }`;

  const getHeaderLabel = (key, label) => {
    if (sortConfig.key === key) {
      const arrow = sortConfig.direction === "asc" ? "▲" : "▼";
      return `${label} ${arrow}`;
    }
    return label;
  };

  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold">
          Huellas Docentes del {regresaBienFecha(fecha)}{escuela ? `- ${escuela}` : ""}
        </h2>{Usuario.nivel<=2? <button
          onClick={exportarExcel}
          className="btn btn-success"
        >
          Exportar Excel
        </button>:""}
       
      </div>
      <table className="w-full border-collapse border border-gray-300">
        <thead className="bg-gray-100">
          <tr>
            <th className={getHeaderClass("#")} onClick={() => sortBy("#")}>
              {getHeaderLabel("#", "#")}
            </th>
            <th className={getHeaderClass("docente")} onClick={() => sortBy("docente")}>
              {getHeaderLabel("docente", "Docente")}
            </th>
            <th className={getHeaderClass("materia")} onClick={() => sortBy("materia")}>
              {getHeaderLabel("materia", "Cursos y Materias")}
            </th>
            <th className={getHeaderClass("horarioIngreso")} onClick={() => sortBy("horarioIngreso")}>
              {getHeaderLabel("horarioIngreso", "Horario Marcado")}
            </th>
          </tr>
        </thead>
        <tbody>
          {resumen.map((fila, index) => (
            <tr key={index}>
              <td className="border border-gray-300 px-4 py-2">{index + 1}</td>
              <td className="border border-gray-300 px-4 py-2">{fila.docente}</td>
              <td className="border border-gray-300 px-4 py-2">
                {Object.entries(fila.cursos).map(([curso, materiasSet], i) => (
                  <div key={i}>
                    <strong>{curso}:</strong> {Array.from(materiasSet).join(", ")}
                  </div>
                ))}
              </td>
              <td className="border border-gray-300 px-4 py-2">{fila.horarioIngreso}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ResumenDocentes;
